(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pop-simple-pack-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ps-pack-builder')) {
    customElements.define('ps-pack-builder', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.catalogue = JSON.parse(this.dataset.catalogue);
        this.form = this.querySelector('form');
        this.button = this.querySelector('[data-submit]');
        this.buttonLabel = this.button.textContent;
        this.slots = [...this.querySelectorAll('[data-slot]')];
        this.addEventListener('change', event => {
          const slot = event.target.closest('[data-slot]');
          if (!slot) return;
          if (event.target.matches('[data-design]')) this.populate(slot);
          this.update();
        });
        this.form.addEventListener('submit', event => this.submit(event));
        this.slots.forEach(slot => this.populate(slot));
        this.update();
      }
      design(slot) {
        const option = slot.querySelector('[data-design]').selectedOptions[0];
        return this.catalogue.find(item => item.handle === option?.dataset.handle);
      }
      populate(slot) {
        const design = this.design(slot);
        const select = slot.querySelector('[data-colour]');
        select.replaceChildren(new Option(this.dataset.prompt, ''));
        select.disabled = !design;
        if (design) design.variants.forEach(variant => {
          const option = new Option(variant.title, variant.title);
          option.disabled = !variant.available;
          select.add(option);
        });
        const image = slot.querySelector('[data-preview]');
        image.hidden = !design;
        slot.querySelector('[data-placeholder]').hidden = !!design;
        if (design) { image.src = design.image; image.alt = design.title; }
        else image.removeAttribute('src');
      }
      update() {
        let complete = 0;
        const list = this.querySelector('[data-summary-list]');
        list.replaceChildren();
        this.slots.forEach(slot => {
          const design = this.design(slot);
          const colour = slot.querySelector('[data-colour]').value;
          const variant = design?.variants.find(item => item.title === colour && item.available);
          slot.querySelector('[data-sku]').value = variant?.sku || '';
          if (variant) {
            complete++;
            const item = document.createElement('li');
            item.textContent = `${design.title} — ${colour}`;
            list.append(item);
          }
        });
        this.ready = complete === 3;
        this.querySelector('[data-progress]').textContent = this.dataset.summary.replace('[count]', complete);
        this.button.disabled = !this.ready || this.busy || this.button.dataset.available !== 'true';
      }
      async submit(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.busy) return;
        this.update();
        if (!this.ready || !this.form.reportValidity() || this.button.dataset.available !== 'true') return;
        const error = this.querySelector('[data-error-message]');
        error.hidden = true;
        const data = new FormData(this.form);
        this.busy = true;
        this.update();
        this.button.textContent = this.dataset.busy;
        this.querySelectorAll('select').forEach(select => select.disabled = true);
        try {
          const url = new URL(this.form.action);
          url.pathname = url.pathname.replace(/\/$/, '') + '.js';
          const response = await fetch(url, {method:'POST',body:data,headers:{Accept:'application/json'}});
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          window.location.assign(this.dataset.cartUrl);
        } catch (failure) {
          error.textContent = failure.message || this.dataset.error;
          error.hidden = false;
          this.busy = false;
          this.button.textContent = this.buttonLabel;
          this.slots.forEach(slot => {
            slot.querySelector('[data-design]').disabled = false;
            slot.querySelector('[data-colour]').disabled = !this.design(slot);
          });
          this.update();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
